
<template>
  <!-- first  bot image with floating text-->
  <div >
    <div id="chat-text" @click="toggleChatbot">
    <div class="chatbot-float-text">
    Need Help?<br />Ask BijuleeSewa
    </div>
  </div>
<div id="chat-icon-wrapper" @click="toggleChatbot">
  <img id="chatIcon" src="../assets/chatbotimg5.png" height="60" />
</div>
    
<!-- ChatBot header with logo and toggle -->
<div class="chatbox-container chat-bar-collapsible">
  
   <button id="chat-button" type="button" class="collapsible chat-toggle-hamburger" style="display:none">
  <div class="chatboxtop-row">
  <div class="bot-title-group">
    <img src="@/assets/chatbotimg5.png" alt="APDCLBOT" class="apdclbot-img" /> 
    <div class="bot-title-wrapper">
      <div class="bot-title">BIJULEESEWA</div>
      <div class="chat-subtitle">YOUR DIGITAL ASSISTANT</div>
    </div>
  </div>
  <!---  hamburger with drop down-->
  <b-dropdown variant="link" no-caret right toggle-class="hamburger-dropdown"   menu-class="chat-dd-menu">
    <template #button-content>
      <b-icon icon="list" font-scale="1.8" class="hamburger-icon"></b-icon>
    </template>
    
    <b-dropdown-item @click="toggleChatbot()"><b-icon icon="caret-down-fill" class="dd-icon"></b-icon>  <span class="dd-text"> Minimize Chat</span></b-dropdown-item>
    <b-dropdown-item @click="exitChat()"><b-icon icon="box-arrow-right" class="dd-icon danger"></b-icon> <span class="dd-text"> Exit Chat</span></b-dropdown-item>
      <b-dropdown-divider></b-dropdown-divider>
     <b-dropdown-item href="https://apdcl.org/website/ApplyNewConn" target="_blank" rel="noopener noreferrer"> <b-icon icon="plug" class="dd-icon"></b-icon><span class="dd-text"> Apply for New Connection</span> 
  </b-dropdown-item>
    
    
  </b-dropdown>
</div>

</button>

<div class="container" id="chatbotContainer" >
 

<div class="messageBox"  ref="chatbox">
  <!-- <div id="GraphContainer"></div> -->
 <br>
  <div v-for="(message, index) in messages" :key="index">
    <span>
    <div :class="message.from == 'user' ? 'messageFromUser' : 'messageFromApdcl'">
      <div v-if="message.from === 'user'" class="userAvatar">
        <!--<i class="fas fa-user">User</i>-->

        <b-icon icon="person-circle" font-scale="2" variant="dark" class="bot-icon"></b-icon>

      </div>
      <div v-else class="apdclAvatar">
        
        <img src="@/assets/chatbotimg5.png" alt="APDCLBOT" class="apdclbot-img" />
      
      </div>
      <div :class="message.from == 'user' ? 'userMessageWrapper' : 'ApdclMessageWrapper'">
       <template v-if="message.isTyping">
  <div class="typingIndicatorWrapper">
    <div class="car-loader">
      <!-- SVG from CodePen -->
      <svg class="car" width="102" height="40" xmlns="http://www.w3.org/2000/svg">
        <defs>
  <linearGradient id="carGradient" x1="0%" y1="0%" x2="100%" y2="0%">
    <stop offset="0%" stop-color="#ff7a18"/>
    <stop offset="100%" stop-color="#df5d00"/>
  </linearGradient>
</defs>
        <g transform="translate(2 1)" stroke="#df5d00" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
          <path class="car__body" d="M47.293 2.375C52.927.792 54.017.805 54.017.805c2.613-.445 6.838-.337 9.42.237l8.381 1.863c2.59.576 6.164 2.606 7.98 4.531l6.348 6.732 6.245 1.877c3.098.508 5.609 3.431 5.609 6.507v4.206c0 .29-2.536 4.189-5.687 4.189H36.808c-2.655 0-4.34-2.1-3.688-4.67 0 0 3.71-19.944 14.173-23.902zM36.5 15.5h54.01" stroke-width="3"/>
          <ellipse class="car__wheel--left" stroke-width="3.2" fill="#FFF" cx="83.493" cy="30.25" rx="6.922" ry="6.808"/>
          <ellipse class="car__wheel--right" stroke-width="3.2" fill="#FFF" cx="46.511" cy="30.25" rx="6.922" ry="6.808"/>
          <path class="car__line car__line--top" d="M22.5 16.5H2.475" stroke-width="3"/>
          <path class="car__line car__line--middle" d="M20.5 23.5H.4755" stroke-width="3"/>
          <path class="car__line car__line--bottom" d="M25.5 9.5h-19" stroke-width="3"/>
        </g>
      </svg>
    </div>
  </div>
</template>

<template v-else>
   <div :class="message.from == 'user' ? 'userMessageContent' : 'ApdclMessageContent'">   
  <div v-html="message.data"></div> </div>
  
</template>
       

     
        <p class="timeClass" v-html="message.time"></p>
      </div>
    </div>
  </span>
  </div>
  <div v-if="menuLevel !== 'MAIN' && showBackToMenu" style="text-align: right; margin: 0 0 0 0">
    <div style="position: relative; display: inline-block;">
  <button class="btn back-menu-btn" @click="backToMenu()" aria-label="Back to Menu" title="Back to Menu">
    🏠≡  
  </button>
 
</div>
</div>
</div>


<div class="inputContainer">
 
 
  <input
    v-model="currentMessage"
    type="text"
    id="userInputText"
    class="messageInput"
    placeholder="Type Here..."
    @keyup.enter="sendMessage(currentMessage)"
    style="font-size:0.9rem !important"
  />
  <button
    @click="sendMessage(currentMessage)"
    class="askButton"
  >
    Send
  </button>
</div>
</div>
</div>
</div>
</template>

<script>
import Chart from 'chart.js';
import axios from 'axios';
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

var consNo = "";
var i=1;
var d = new Date();
var dateTime = d.toString().split("GMT")[0];

export default {
  name: 'ChatBox',
  data() {
    return {
      currentMessage: '',
      lastMessage:'',
      chatOpenedOnce: false,
      chatRestarted: false,
      loadingMessage: null,
      showBackToMenu: false,
      ConsName:'',
      consNo:'',
      isResendOTP: false,
      mobileTemp: "",
      emailTemp:"",
      applicationTemp:"" ,
      allTips: [],
      allDocs:[],
      carouselItems: [],
      carouselType: "",   // to check if "tips" or "docs"
      currentCarouselIndex: 0,
      autoSlideTimer: null,
      categoryList: [],
      catCode:"",
      Category: "",
      Load: "",
      Owner: "",
      currentCategory: "", //breadcrumb/submenu heading
      menuLevel: "MAIN",   // MAIN | SUB
      nextIsMenu: false  , //decide whether the API should receive isMenu: "Y" or isMenu: " "
      

      
      
  messages: [],
  menu:{},
  fetchMsg:{
    defaultMsg:"Fetching Your data. Please wait.",
    bill:"Please wait a moment while I retrieve your information.",
    payment:" Please wait a moment while I retrieve your information.",
    balance:"Please wait a moment while I retrieve your balance.",
    recharge:"Please wait a moment while I retrieve your information.",
    statement:"Please wait a moment while I retrieve your information.",
    consumptionHistory:"Please wait a moment while I retrieve your information.",
    balanceHistory:"Please wait a moment while I retrieve your information.",
  }
  
    };
  },
  methods: {

    
showResendButtonTimer() {
  
  this.$nextTick(() => {
    this.stopResendTimer();
        const placeholders = document.querySelectorAll('.resend-placeholder');
    const placeholder = placeholders[placeholders.length - 1];

    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }

    let countdown = 60;
    placeholder.innerHTML = `<br><span id="resend-timer" style="color: grey; font-weight: 500;">Resend OTP in ${countdown} seconds</span>`;

    this.timerInterval = setInterval(() => {
      countdown--;
      const timerEl = document.getElementById('resend-timer');
      if (timerEl) {
        timerEl.textContent = `Resend OTP in ${countdown} seconds`;
      }

      if (countdown <= 0) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;

        // Show Resend OTP button
        placeholder.innerHTML = `<br><button class="resendOTP"
          style="margin-top: 8px; padding: 6px 12px; background-color: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer;">
          Resend OTP
        </button>`;

        const btn = placeholder.querySelector('.resendOTP');
        if (btn) {
          btn.addEventListener('click', () => {
            btn.disabled = true;
            btn.textContent = 'Sending...';
            this.currentMessage = 'Resend OTP';
            this.sendMessage('Resend OTP');
          }, { once: true });
        }

        const chatbox = this.$refs.chatbox;
        if (chatbox) {
          chatbox.scrollTop = chatbox.scrollHeight;
        }
      }
    }, 1000);
  });
},

stopResendTimer() {
  if (this.timerInterval) {
    clearInterval(this.timerInterval);
    this.timerInterval = null;
  }
  this.countdown = 0;
  const placeholder = document.querySelector(".resend-placeholder");
  if (placeholder) {
    placeholder.innerHTML = '';
  }
},
    clearChat()
    {
      var d = new Date();
      var dateTime = d.toString().split("GMT")[0];
      this.messages=[{
      from: 'Apdcl',
      // data: "Hi, I am BijuleeSewa bot, Please enter your 12 digit consumer number ",
      data: "Hi there! How can I assist you today?",
      time: dateTime
      }];
    },


  backToMenu() {
  this.lastMessage = "";
  this.currentMessage = "";

  // reset calculators only
  this.resetServiceCalculator();
  this.resetDisplayGraph();

  // 🔹 SUB → MAIN
  if (this.menuLevel === "SUB") {
    this.menuLevel = "MAIN";
    this.currentCategory = "";

    this.messages.push({
      ...this.menu,
      id: `menu-${Date.now()}`
    });

    this.$nextTick(() => {
      this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;
    });
    return;
  }


},
removeOldMenu() {
  this.messages = this.messages.filter(m => !m.isMenuMsg);
},
resetDisplayGraph(){

    this.messages = this.messages.filter(m => !m.isGraph);
},

resetServiceCalculator() {

  // Stop auto UI
  this.stopAutoSlide();

  // Reset calculator data
  this.allTips = [];
  this.allDocs = [];
  this.currentCarouselIndex = 0;
  this.currentTipIndex = 0;

  // Remove only calculator messages (STRICT match)
  this.messages = this.messages.filter(
    m => !m.isServiceCalc
  );

  // Reset calculator DOM fields
  this.$nextTick(() => {
    const resetMap = {
      selectCategory: "0",
      landOwner: "0",
      load: "",
      estError: "",
      loadRange: ""
    };

    Object.keys(resetMap).forEach(id => {
      const el = document.getElementById(id);
      if (!el) return;

      if (el.tagName === "SELECT" || el.tagName === "INPUT") {
        el.value = resetMap[id];
      } else {
        el.innerHTML = "";
      }
    });
  });
},

  toggleChatbot() {
  const chatContainer = document.querySelector(".chatbox-container");
   const content = document.getElementById("chatbotContainer");
  const chatButton = document.getElementById("chat-button");
  const chatIcon = document.getElementById("chatIcon");
  const chatText = document.getElementById("chat-text");

  // Toggle open/closed on the WHOLE chatbox-container
  chatContainer.classList.toggle("chatbox-open");

  if (chatContainer.classList.contains("chatbox-open")) {
    content.classList.add("chatbox-open");
    chatButton.style.display = "block"; // Show header (with hamburger)
    chatIcon.style.display = "none";    // Hide floating icon
    chatText.style.display = "none";    // Hide "Need Help?" text

    // First-time welcome messages
    if (!this.chatOpenedOnce && !this.chatRestarted) {
      this.chatOpenedOnce = true;
      this.showWelcomeMessages();
    }
    this.chatRestarted = false;
  } else {
     content.classList.remove("chatbox-open");
    chatButton.style.display = "none"; // Hide header
    chatIcon.style.display = "block";  // Show floating icon
    chatText.style.display = "block";  // Show "Need Help?" text
  }
},

 
restartChat() {
  consNo = "";
  this.menu = {};
  this.messages = [];
  this.chatOpenedOnce = false;
  this.chatRestarted = true;

  this.showWelcomeMessages();
},

exitChat() {
  const dateTime = new Date().toString().split("GMT")[0];
  //const content = document.getElementById("chatbotContainer");
  //content.style.pointerEvents = "none";

  this.showBackToMenu = false;
  this.messages.push({
    from: 'Apdcl',
    data: "Sure, if you ever need assistance in the future, feel free to reach out. Have a great day!",
    time: dateTime
  });
  this.messages.push({
    from: 'Apdcl',
    data: "Exiting the Chat",
    time: dateTime
  });

 this.currentMessage = '';
  this.otpReq = "";               
  this.lastMessage = "";        
  this.consNo = "";               
  this.menu = {};
  this.nextIsMenu="";
  //this.isResendOTP = false; 
  
  document.getElementById("userInputText").placeholder = "Type Here...";

  /*axios.post('https://uat.apdclrms.com/bot/bs/destroySession',
  {}, 
  {
    headers: {
       'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json'
       
     
    }
  }
)
.then(response => {
  console.log("Session destroyed:", response.data);
})
.catch(error => {
  console.error("Error destroying session:", error);
});*/

  setTimeout(() => {
    
    this.chatOpenedOnce = false;
    this.chatRestarted = false;
    this.consNo = "";
    this.menu = {};
     this.stopAutoSlide();
     this.allTips = [];
      this.currentTipIndex = 0;
    this.showBackToMenu = false;
    this.messages = [];
      
    //console.log("status::", this.menu); // Properly logs the object
//console.log("menu empty?", Object.keys(this.menu).length === 0);

    // Close chatbox 
    const content = document.getElementById("chatbotContainer");
    const chatButton = document.getElementById("chat-button");
    const chatIcon = document.getElementById("chatIcon");
    const chatText = document.getElementById("chat-text");
    const chatContainer = document.querySelector(".chatbox-container");

    
    content.classList.remove("chatbox-open");
    chatContainer.classList.remove("chatbox-open");
    chatButton.style.display = "none";
    chatIcon.style.display = "block";
    chatText.style.display = "block";
    this.showBackToMenu = false;
  }, 2000); 

  this.$nextTick(() => {
  
  this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;
});
},



showWelcomeMessages() {
  const time = new Date().toString().split("GMT")[0];

  // 1. First welcome message
  this.messages.push({
    from: 'Apdcl',
    data: "Hi, I am BijuleeSewa bot.",
    time
  });

  this.$nextTick(() => {
    this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;
  });

  // 2. typing indicator 
  setTimeout(() => {
    const typingTime = new Date().toString().split("GMT")[0];

    this.messages.push({
      from: 'Apdcl',
      isTyping: true,
      time: typingTime
    });

    this.$nextTick(() => {
      this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;
    });

    // second message after 1.5 seconds
    setTimeout(() => {
      const secondTime = new Date().toString().split("GMT")[0];

      this.messages.push({
        from: 'Apdcl',
        data: "Please enter your 12 digit consumer number.",
        time: secondTime
      });
      this.lastMessage = "Enter consumer number";
      // Remove typing indicator after message appears
      this.messages = this.messages.filter(msg => !msg.isTyping);

      /*this.$nextTick(() => {
        this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;
      });*/
       this.$nextTick(() => {
  const chatbox = this.$refs.chatbox;
  if (chatbox) {
    chatbox.scrollTop = chatbox.scrollHeight;
  }
})

    }, 1500);
  }, 1000);
},
showAnimatedMessage(message, style = '') {
  const time = new Date().toString().split("GMT")[0];

  // 1. Typing indicator
  this.messages.push({
    from: 'Apdcl',
    isTyping: true,
    time
  });

  this.$nextTick(() => {
    this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;
  });

  // 2. Replace typing with actual message
  setTimeout(() => {
    this.messages = this.messages.filter(msg => !msg.isTyping);

    this.messages.push({
      from: 'Apdcl',
      data: `<span style="${style}">${message}</span>`,
      time: new Date().toString().split("GMT")[0]
    });

    this.$nextTick(() => {
      this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;
    });
  }, 1200);
},
  
 fetchAnimation(message, callback) {
  const time = new Date().toString().split("GMT")[0];

  // Show typing indicator
  this.messages.push({
    from: 'Apdcl',
    isTyping: true,
    time
  });

  this.$nextTick(() => {
    this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;
  });

  
  setTimeout(() => {
    
    this.messages = this.messages.filter(msg => !msg.isTyping);

    
   

    const loadingMsg = {
      from: 'Apdcl',
      data: `${message} <br><b-icon icon='three-dots' animation='cylon' font-scale='2'></b-icon>`,
      time: new Date().toString().split("GMT")[0]
    };

    this.messages.push(loadingMsg);
    this.loadingMessage = loadingMsg; 

    this.$nextTick(() => {
      this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;
    });

    // API call
    if (typeof callback === 'function') {
      callback();
    }
  }, 1000);
},


  showTip(index) {
  const tip = this.allTips[index];
  const totalTips = this.allTips.length;

  const navigationButtons = (() => {
    if (index === 0 && totalTips > 1) {
      return `
        <button onclick="window.__vue__.showNextCarousel()" 
          style="padding:5px 15px; background:#1877F2; color:white; border:none; border-radius:5px;">
          Next ▶
        </button>`;
    } else if (index === totalTips - 1) {
      return `
        <button onclick="window.__vue__.showPrevCarousel()" 
          style="padding:5px 15px; background:#1877F2; color:white; border:none; border-radius:5px;">
          ◀ Previous
        </button>`;
    } else {
      return `
        <div style="display:flex; justify-content:space-between; gap:10px;">
          <button onclick="window.__vue__.showPrevCarousel()" style="padding:5px 15px; background:#1877F2; color:white; border:none; border-radius:5px;">◀ Previous</button>
          <button onclick="window.__vue__.showNextCarousel()" style="padding:5px 15px; background:#1877F2; color:white; border:none; border-radius:5px;">Next ▶</button>
        </div>`;
    }
  })();

  const tipHTML = `
    <div style="background:linear-gradient(135deg,#fffefa,#f7f7f5);
      border-left:5px solid #df5d00; padding:20px; border-radius:12px;">
      
      <div style="font-weight:bold; font-size:1.2rem; color:#df5d00; margin-bottom:15px;">
        💡 Power-Saving Tips (${index + 1}/${totalTips})
      </div>

      <div style="margin-bottom:20px; color:#444;">
        <span style="color:#34a853; font-size:1.2rem;">✅</span>
        ${tip}
      </div>

      ${navigationButtons}
    </div>
  `;

  document.getElementById("tip-carousel").innerHTML = tipHTML;
},
showDoc(index) {
  const doc = this.allDocs[index];
  const totalDocs = this.allDocs.length;

  const navigationButtons = (() => {
    if (index === 0 && totalDocs > 1) {
      return `
        <button onclick="window.__vue__.showNextCarousel()" 
          style="padding:5px 15px; background:#1877F2; color:white; border:none; border-radius:5px;">
          Next ▶
        </button>`;
    } else if (index === totalDocs - 1) {
      return `
        <button onclick="window.__vue__.showPrevCarousel()" 
          style="padding:5px 15px; background:#1877F2; color:white; border:none; border-radius:5px;">
          ◀ Previous
        </button>`;
    } else {
      return `
        <div style="display:flex; justify-content:space-between; gap:10px;">
          <button onclick="window.__vue__.showPrevCarousel()" style="padding:5px 15px; background:#1877F2; color:white; border:none; border-radius:5px;">◀ Previous</button>
          <button onclick="window.__vue__.showNextCarousel()" style="padding:5px 15px; background:#1877F2; color:white; border:none; border-radius:5px;">Next ▶</button>
        </div>`;
    }
  })();

  const docHTML = `
    <div style="background:linear-gradient(135deg,#fffefa,#f7f7f5);
      border-left:5px solid #df5d00; padding:20px; border-radius:12px;">
      
       <div style="font-weight:bold; font-size:1rem; color:#df5d00; margin-bottom:15px;">
       Documents required for NSC (${index + 1}/${totalDocs})
      </div>

      <div style="margin-bottom:20px; color:#444;">
         <span style="color:#34a853; font-size:1.2rem;">✅</span>
        ${doc}
      </div>

      ${navigationButtons}
    </div>
  `;

  document.getElementById("nscdocs-carousel").innerHTML = docHTML;
},

   showNextCarousel() {
  if (this.currentCarouselIndex < this.carouselItems.length - 1) {
    this.currentCarouselIndex++;
  }

  if (this.carouselType === "tips") {
    this.showTip(this.currentCarouselIndex);
  } else if (this.carouselType === "docs") {
    this.showDoc(this.currentCarouselIndex);
  }

  if (this.currentCarouselIndex === this.carouselItems.length - 1) {
    this.stopAutoSlide();
  }
},

showPrevCarousel() {
  if (this.currentCarouselIndex > 0) {
    this.currentCarouselIndex--;
  }

  if (this.carouselType === "tips") {
    this.showTip(this.currentCarouselIndex);
  } else if (this.carouselType === "docs") {
    this.showDoc(this.currentCarouselIndex);
  }
},

startAutoSlide() {
  if (this.autoSlideTimer) clearInterval(this.autoSlideTimer);

  this.autoSlideTimer = setInterval(() => {
    if (this.currentCarouselIndex < this.carouselItems.length - 1) {
      this.currentCarouselIndex++;

      if (this.carouselType === "tips") this.showTip(this.currentCarouselIndex);
      if (this.carouselType === "docs") this.showDoc(this.currentCarouselIndex);

    } else {
      clearInterval(this.autoSlideTimer);
    }
  }, 5000);
},

stopAutoSlide() {
  if (this.autoSlideTimer) {
    clearInterval(this.autoSlideTimer);
    this.autoSlideTimer = null;
  }
},

stopAnimation() {
  if (this.loadingMessage) {
    this.messages = this.messages.filter(msg => msg !== this.loadingMessage);
    this.loadingMessage = null;
  }
},  
/***     Estimate Service Calculator */
showCalcError(msg) {
  const errBox = document.getElementById("estError");
  if (!errBox) return;

  errBox.innerText = msg;

  // Restart animation
  errBox.classList.remove("error-animate");
  void errBox.offsetWidth;
  errBox.classList.add("error-animate");
},

  highlightInput(id) {
  const el = document.getElementById(id);
  if (!el) return;
  el.classList.remove("input-error");
  void el.offsetWidth; // restart animation
  el.classList.add("input-error");
},
showServiceCalculatorMenu() {
  const time = new Date().toString().split("GMT")[0];

  let options = `<option value="0">--- Select ---</option>`;
  this.categoryList.forEach(element => {
    const code = element.category_CODE.split("-")[0];
    if (code !== "76" && code !== "77") {
      options += `<option value="${code}">${element.category_CODE}</option>`;
    }
  });

  const html = `
    <div style=" background:linear-gradient(135deg,#fffefa,#f7f7f5);
      border-left:5px solid #df5d00; padding:20px; border-radius:12px;">
      <b style="font-weight:bold; font-size:1rem; color:#df5d00; margin-bottom:15px;">New Connection Estimate Calculation</b><br><br>

      <label><b>Select Category <b style="color:red">*</b></b></label>
      <select id="selectCategory"
        onchange="window.__vue__.changeSelectFromChatbot()"
        style="width:100%;padding:6px;margin-bottom:10px;">
        ${options}
      </select>

      <label><b>Enter Load (KW) <b style="color:red">*</b></b></label>
      <input id="load" type="number"
        style="width:100%;padding:6px;margin-bottom:5px;" />

      <span id="loadRange" style="font-size:12px;color:#555;"></span>

      <div id="landOwnerDiv" style="margin-top:10px;">
        <label><b>Is Applicant Owner of the Land? <b style="color:red">*</b></b></label>
        <select id="landOwner"
          style="width:100%;padding:6px;margin-top:5px;">
          <option value="0">--- Select ---</option>
          <option value="Y">Yes</option>
          <option value="N">No</option>
        </select>
      </div>

      <div id="estError" style="color:red; font-size:13px; margin-top:6px;"></div>

      <button
        onclick="window.__vue__.submitestimatecalculator()"
        style="width:100%;margin-top:12px;background:#004aad;color:white;
               border:none;padding:8px;border-radius:6px;font-weight:bold;">
        Calculate
      </button>
    </div>
  `;

  this.showAnimatedMessage(html);
this.lastMessage = "SERVICE_CALCULATOR";

setTimeout(() => {
  this.$nextTick(() => {
  

    const errBox = document.getElementById("estError");

    const clearError = () => {
      if (!errBox) return;
      errBox.innerText = "";
      errBox.classList.remove("error-animate");

      ["load", "selectCategory", "landOwner"].forEach(id => {
        const el = document.getElementById(id);
        if (el) el.classList.remove("input-error");
      });
    };

    // Attach real-time listeners
    const loadInput = document.getElementById("load");
    if (loadInput) loadInput.addEventListener("input", clearError);

    const catInput = document.getElementById("selectCategory");
    if (catInput) catInput.addEventListener("change", clearError);

    const ownerInput = document.getElementById("landOwner");
    if (ownerInput) ownerInput.addEventListener("change", clearError);

  });
}, 1500)
},

changeSelectFromChatbot() {
        const catCode = document.getElementById("selectCategory").value;
  const sel = document.getElementById("selectCategory");
  const selectText = sel.options[sel.selectedIndex].text;

  // HT categories
  if (catCode > 55 && catCode != 69 && catCode != 75 && catCode != 72 && catCode != 70) {
    document.getElementById("landOwnerDiv").style.display = "block";
    document.getElementById("loadRange").innerHTML = "(Load Range : 31KW - 150KW)";
  }
  else if (catCode == 70) {
    document.getElementById("landOwnerDiv").style.display = "none";
    document.getElementById("loadRange").innerHTML = "(Load Range : 31KW - 150KW)";
  }
  else {
    const link = this.categoryList.filter(obj => obj.category_CODE == selectText);
    if (link.length) {
      document.getElementById("loadRange").innerHTML =
        `(Load Range : ${link[0].lower_LOAD_KW}KW - ${link[0].higher_LOAD_KW}KW)`;
    }

    if (catCode == 54 || catCode == 55 || catCode == 69) {
      document.getElementById("landOwnerDiv").style.display = "none";
    } else {
      document.getElementById("landOwnerDiv").style.display = "block";
    }
  }
},
submitestimatecalculator() {
  const cat = Number(document.getElementById("selectCategory").value);
  const load = document.getElementById("load").value;
  const landOwner = document.getElementById("landOwner").value;
  const errBox = document.getElementById("estError");
  

  /* ---------- Error Helper ---------- */
  const showError = (msg) => {
    if (!errBox) return;
    errBox.innerText = msg;
    errBox.classList.remove("error-animate");
    void errBox.offsetWidth;
    errBox.classList.add("error-animate");
  };

  /* ---------- VALIDATIONS ---------- */

  if (!cat || cat === 0) {
    showError("⚠ Please select a Category.");
    return;
  }

  if (load === "" || isNaN(parseFloat(load))) {
    showError("⚠️ Please enter valid Load.");
    return;
  }

  const loadNum = parseFloat(load);

  // HT validation
  if (cat > 55 && ![69, 70, 72, 75].includes(cat)) {
    if (loadNum < 31 || loadNum > 150) {
      showError("⚠️ Load must be between 31KW and 150KW");
      return;
    }
    if (landOwner === "0") {
      showError("⚠️ Please select Land Owner (Yes/No).");
      return;
    }
  }

  // LT validation
  const sel = document.getElementById("selectCategory");
  const selectText = sel.options[sel.selectedIndex].text;
  const link = this.categoryList.filter(o => o.category_CODE === selectText);

  if (link.length && cat <= 55) {
    const lower = Number(link[0].lower_LOAD_KW);
    const upper = Number(link[0].higher_LOAD_KW);

    if (loadNum < lower || loadNum > upper) {
      showError(`⚠️ Load must be between ${lower}KW and ${upper}KW.`);
      return;
    }

    if (landOwner === "0" && ![54, 55, 69].includes(cat)) {
      showError("⚠️ Please select Land Owner (Yes/No).");
      return;
    }
  }

  /* ---------- API PAYLOAD ---------- */

  const payload = {
    consNo: this.consNo || "",
    otpReq: "",
    otpValidate: "",
    otp: "",
    isMenu: "",
    mobNo: "",
    email: "",
    applNo: "",
    cat: cat,
    load: load,
    botMsg: "New Connection Estimate Calculation"
  };

  /* ---------- API CALL ---------- */

  this.fetchAnimation(
    "Please wait a moment while I calculate your estimate...",
    async () => {
      try {
        const response = await axios.post(
          "https://uat.apdclrms.com/bot/bs/getBotResponse",
          payload,
          {
            headers: {
      
               'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json'
       
            }
          }
        );
 //console.log("📥 Raw Response from API:", response.data);
        this.stopAnimation();

        if (!response.data || !response.data.msg) {
          this.showAnimatedMessage("⚠️ Something went wrong. Try again.");
          return;
        }

        /* ---------- PARSE RESPONSE ---------- */

        const values = {};
        response.data.msg.split(",").forEach(p => {
          const [k, v] = p.split("=");
          values[k.trim()] = Number(v);
        });

        const serviceConnectionCharge =
          Number(values.serviceConnectionCharge || 0);

      

        let loadSecurity = 0;

        if (landOwner === "N") {
          loadSecurity = Number(values.otherLoad || 0);
        } else {
          loadSecurity = Number(values.normalLoad || 0);
        }

        let tableRows = [];

        /* ---------- HT CONSUMERS ---------- */
        if (cat > 55 && ![69, 70, 72, 75].includes(cat)) {
          const ls = loadSecurity * loadNum;
          const costOfConstruction = serviceConnectionCharge * loadNum;

          const total =
            ls +
            Number(values.meterCost || 0) +
            Number(values.installationCharge || 0) +
            costOfConstruction;

          tableRows = [
            ["Load Security", `₹${ls.toFixed(2)}`],
            ["Meter Cost (without GST)", `₹${values.meterCost}`],
            ["Installation Charge", `₹${values.installationCharge}`],
            ["Cost of Service Connection", `₹${costOfConstruction.toFixed(2)}`],
            ["Total Cost", `₹${total.toFixed(2)}`]
          ];
        }

        /* ---------- CATEGORY 70 ---------- */
        else if (cat === 70) {
          const costOfConstruction = serviceConnectionCharge * loadNum;

          const total =
            Number(values.energyCharge || 0) +
            Number(values.meterSecurityCost || 0) +
            Number(values.disconnectionCharge || 0) +
            costOfConstruction;

          tableRows = [
            ["Energy Charge", `₹${values.energyCharge}`],
            ["Meter Security", `₹${values.meterSecurityCost}`],
            ["Disconnection Charge", `₹${values.disconnectionCharge}`],
            ["Cost of Service Connection", `₹${costOfConstruction.toFixed(2)}`],
            ["Total Cost", `₹${total.toFixed(2)}`]
          ];
        }

        /* ---------- 54 / 55 / 69 ---------- */
        else if ([54, 55, 69].includes(cat)) {
          const total =
            Number(values.energyCharge || 0) +
            Number(values.meterSecurityCost || 0) +
            Number(values.disconnectionCharge || 0);

          tableRows = [
            ["Energy Charge", `₹${values.energyCharge}`],
            ["Meter Security", `₹${values.meterSecurityCost}`],
            ["Disconnection Charge", `₹${values.disconnectionCharge}`],
            ["Total Cost", `₹${total.toFixed(2)}`]
          ];
        }

        /* ---------- LT CONSUMERS (WITH SMART) ---------- */
        else {
          const totalCost =
            loadSecurity +
            Number(values.meterCost || 0) +
            Number(values.installationCharge || 0);

          let meterCostSmart = 0;
          let totalCostSmart = 0;

          if (loadNum < 5) {
            meterCostSmart = Number(values.smartSinglePhase || 0);
            totalCostSmart =
              loadSecurity +
              meterCostSmart +
              Number(values.installationCharge || 0);
          } else {
            meterCostSmart = Number(values.smartThreePhase || 0);
            totalCostSmart =
              loadSecurity +
              meterCostSmart +
              Number(values.installationCharge || 0);
          }

          tableRows = [
            ["Load Security", `₹${loadSecurity}`, `₹${loadSecurity} (for postpaid)`],
            ["Meter Cost (without GST)", `₹${values.meterCost}`, `₹${meterCostSmart}`],
            ["Installation Charge", `₹${values.installationCharge}`, `₹${values.installationCharge}`],
            ["Total Cost", `₹${totalCost.toFixed(2)}`, `₹${totalCostSmart.toFixed(2)}`]
          ];
        }

        /* ---------- RENDER TABLE ---------- */

        let html = `
          <div style="width:97%;background:linear-gradient(135deg,#fffefa,#f7f7f5);
          border-left:5px solid #df5d00;padding:15px;border-radius:12px;margin:10px auto;">
          <table style="width:100%;border-collapse:collapse;background:#fff;">
        `;

        const isSmart = tableRows[0].length === 3;

        html += isSmart
          ? `<tr><th colspan="3">New Connection Estimate Details</th></tr>
             <tr><th>Item</th><th>Cost</th><th>Cost (Smart)</th></tr>`
          : `<tr><th colspan="2">New Connection Estimate Details</th></tr>
             <tr><th>Item</th><th>Cost</th></tr>`;

        tableRows.forEach(r => {
          html += "<tr>" + r.map(c => `<td>${c}</td>`).join("") + "</tr>";
        });

        html += "</table></div>";

        this.messages.push({
          from: "Apdcl",
          data: html,
          time: new Date().toString().split("GMT")[0]
        });

        this.showBackToMenu = true;

      } catch (err) {
        this.stopAnimation();
        console.error(err);
        this.showAnimatedMessage("⚠️ Error calculating estimate.");
      }
    }
  );
},



sendMessage(message) {
  let otpReq = this.otpReq || "";
  let otpValidate = "";
  let otp = "";
  let mobile = "";
  let email = "";
  let applNo = "";
  let botMsg = "";
  
 /* const consNoRegex = /^\d{12}$/;*/
  const d = new Date();
  const dateTime = d.toString().split("GMT")[0];
  const sdList=["001","002","003","004","005","006","009","010","011","013","014","015","016","017","021","022","023","024","025","027","028","029","030","032","033","034","035","037","038","039","040","041","042","044","045","046","047","048","051","052","053","054","055","056","057","058","059","060","061","063","064","065","066","070","071","072","076","077","078","079","080","083","084","085","086","088","089","090","091","093","094","095","096","099","100","101","105","106","107","108","112","113","114","115","116","119","120","121","122","123","124","125","126","127","129","130","132","133","134","135","138","139","140","141","142","143","144","146","147","148","149","150","151","152","153","154","155","156","158","159","160","161","162","163","164","165","166","167","170","171","172","173","175","176","177","178","181","182","183","184","185","188","189","192","193","194","195","196","198","199","200","201","204","207","208","209","210","212","213","214","217","218","219","220","221","224","226","227","228","229","230","231","232","233","234","236","237","299"];
  

 if (this.currentMessage.trim() === '') {
  
this.showAnimatedMessage('⚠️ Please Type Something!', 'color: red; font-weight: 600;');
 
    return;
  }
//Adding the user's message to the chat UI 

if (this.currentMessage  !== 'Resend OTP') {
     this.messages.push({
    from: 'user',
    data: message,
    time: dateTime
  });
  }
  // Check for Resend OTP message
if (this.currentMessage === 'Resend OTP') {
  
  //console.log("current message resend otp",this.lastMessage);
   otpReq = "R";
  otpValidate = ""; 
  otp = "";
  this.lastMessage = "Re-enter OTP";
}
  //consumer number validation
  else if (this.lastMessage === "Enter consumer number" ) {
    //console.log("last message inside enter consumer number",this.lastMessage);
    const consumerinput = this.currentMessage.replace(/\s+/g, '');
    const prefix = consumerinput.substring(0, 3);
    if (consumerinput.length === 12 && sdList.includes(prefix) ) {
      consNo = consumerinput;

      otpReq = "Y";  
      this.lastMessage = "Enter OTP";  
      //console.log("consNo inside enter consumer number", consNo);
      
    }

    else if (consumerinput .length !== 12 || !sdList.includes(prefix)) {
    
this.showAnimatedMessage('⚠️ Please enter a valid 12-digit consumer number!', 'color: red; font-weight: 600;');
      
      this.lastMessage = "Enter consumer number"; 
      this.currentMessage = '';
      
      return;
    }
  }

  else if (this.lastMessage === "Enter OTP" || this.lastMessage === "Re-enter OTP") {
  // OTP validation
  if (this.currentMessage.length === 6) {
    otp = message;
    otpValidate = "Y";
    otpReq = " ";
  } else {
    this.showAnimatedMessage('⚠️ Please enter a valid 6 digit OTP number sent to your registered number!', 'color: red; font-weight: 600;');
    this.currentMessage = '';
    return;
  }
}

  // Menu
  else if (/menu/i.test(this.currentMessage)) {

  
  this.menuLevel = "MAIN";
  this.currentCategory = "";

  this.removeOldMenu();      
  this.messages.push(this.menu);
  this.showBackToMenu = true;
  this.currentMessage = '';

  this.$nextTick(() => {
    this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;
  });

  return;
}

  // Exit
  else if (/exit/i.test(this.currentMessage)) {
    
    this.exitChat();
    this.showBackToMenu = false;
    return;
  }

  
  else if (this.lastMessage === "Update mobile number") {
         console.log("mobileno", this.mobileTemp )
        const mobileRegex = /^\d{10}$/;

  
  if (!this.mobileTemp) {
    if (!mobileRegex.test(message)) {
       this.showAnimatedMessage(`⚠️ Invalid mobile number. Please enter a valid 10-digit mobile number.`, 'color: red; font-weight: 600;');
      
      this.currentMessage = '';
      return;
    }

    
    this.mobileTemp = message;
    this.showAnimatedMessage(`⚠️ You entered <b>${message}</b>. Do you want to update this number? (Yes/No)`, 'color: red; font-weight: 600;');
    this.currentMessage = '';
    return;
  } else {
    
    if (message.toLowerCase() === "yes") {
      
       
      mobile = this.mobileTemp; 
      botMsg = "Update mobile number";
      otpReq = "Y";  
      //this.lastMessage = "Enter OTP";
    } else {

      this.showAnimatedMessage(` Mobile number update cancelled. Returning to menu`, 'color: red; font-weight: 600;');
      
      this.lastMessage = '';
      this.mobileTemp = '';
      this.currentMessage = '';
      setTimeout(() => {
         this.menuLevel = "MAIN";
         this.nextIsMenu = true;
          this.currentCategory = ""; 
         this.removeOldMenu();
  this.messages.push(this.menu);
  this.showBackToMenu = true;

  this.$nextTick(() => {
    this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;
  });
}, 2000);
       
      return;
    }
  }
}
else if (this.lastMessage === "Update email id") {
        const  emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  
  if (!this.emailTemp) {
    if (!emailRegex.test(message)) {
       this.showAnimatedMessage(`⚠️ Invalid email ID. Please enter a valid email.`, 'color: red; font-weight: 600;');
      
      this.currentMessage = '';
      return;
    }

    
    this.emailTemp = message;
    this.showAnimatedMessage(`⚠️ You entered <b>${message}</b>. Do you want to update this email ID? (Yes/No)`, 'color: red; font-weight: 600;');
    this.currentMessage = '';
    return;
  } else {
    
    if (message.toLowerCase() === "yes") {
      this.lastMessage = ''; 
      email = this.emailTemp; 
      botMsg = "Update email id"; 
      this.mobileTemp = '';
    } 
    
    else {

      this.showAnimatedMessage(`Email Id update cancelled. Returning to menu`, 'color: red; font-weight: 600;');
     
      this.lastMessage = '';
      this.emailTemp = '';
      this.currentMessage = '';
        setTimeout(() => {
         this.menuLevel = "MAIN";
         this.nextIsMenu = true;
          this.currentCategory = ""; 
         this.removeOldMenu();
  this.messages.push(this.menu);
  this.showBackToMenu = true;

  this.$nextTick(() => {
    this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;
  });
}, 2000);
       
      return;
    }
  }
}


  else if (this.lastMessage === "Check application status") {
    applNo = message;
    botMsg = this.lastMessage;
  } else {
    botMsg = this.currentMessage;
  }

if (
    this.mobileTemp && (this.lastMessage === "Enter OTP" || this.lastMessage === "Re-enter OTP" )
) {
    mobile = this.mobileTemp;
    botMsg = "Update mobile number";
}

  // Send data to API
  const dataTosend = JSON.stringify({
    "consNo": consNo,
    "otpReq": otpReq,
    "otpValidate":otpValidate,
    "otp": otp,
    "isMenu": "",
    "mobNo":mobile,
    "email":email,
    "applNo":applNo,
    "botMsg": botMsg
  });
console.log("data to send from SM",dataTosend);
  let config = {
    method: 'post',
    url: 'https://uat.apdclrms.com/bot/bs/getBotResponse',
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json'
       
      
    },
    data: dataTosend
  };
//console.log("dataTosend in send message",JSON.stringify(dataTosend));
  this.fetchAnimation(this.fetchMsg.defaultMsg, () => {
    axios.request(config)
      .then((response) => {
        this.stopAnimation();

        const lastMsg = this.messages[this.messages.length - 1];
                    if (lastMsg && lastMsg.data === 'Sending...') {
                         this.messages.pop(); //remove sending
}
        const dateTime = new Date().toString().split("GMT")[0];

//console.log("Response in SM",JSON.stringify(response));


//condition 1
       if (response.data.status === "success" && response.data.otpGenerated === "Y" && response.data.otpValidated !== "Y") {

        console.log("Entered here ")
                          this.consNo = message;
                          this.ConsName = response.data.consName;
                          this.stopResendTimer();

                          const lastMsg = this.messages[this.messages.length - 1];
                     if (lastMsg && lastMsg.data === 'Sending...') {
                        this.messages.pop(); //remove sending
                                    }  
                                    //check if otp is for update mobile no                 
  const isMobileUpdateOTP =this.mobileTemp && botMsg === "Update mobile number";
                         // Find the last OTP message from Apdcl to update
                             const lastBotMsg = this.messages.slice().reverse().find(
                                         m => m.from === 'Apdcl' && m.data.includes('OTP')
                                          );

                             let updatedMsg = '';
                            if (otpReq === "R" && response.data.responseType==="reSendOTP") 
                                  {
                                    updatedMsg = '✅ OTP has been resent to your mobile number. Please enter 6 digit OTP received in your mobile number<br><span class="resend-placeholder"></span>';
                                  } 
                                  
                                  else if (otpReq === "Y" && response.data.responseType==="otpSend") 

                                  {
                                    updatedMsg = `✅ OTP has been sent to your mobile number.Please enter 6 digit OTP received in your mobile number  <br><span class="resend-placeholder"></span>`;
                                  }

                                  //console.log("lastBotMsg",lastBotMsg);
                                 
                                  //console.log("updatedMsg =", updatedMsg);
                                 
                                 if (isMobileUpdateOTP) {

                                                  // Mobile number update flow
                                                  this.messages.push({
                                                    from: 'Apdcl',
                                                    data: updatedMsg,
                                                    time: dateTime
                                                  });
                                                }
                                                   else {

                                  if (lastBotMsg) {
                                    lastBotMsg.data = updatedMsg; 
                                    lastBotMsg.time = dateTime;
                                  } else {

                                    this.messages.push({
                                      from: 'Apdcl',
                                      data: updatedMsg,
                                      time: dateTime
                                    });
                                  }
                                      
                                }
                                      this.$nextTick(() => {
                                        this.showResendButtonTimer();
                                      });

                                      this.lastMessage = "Enter OTP";

                                      document.getElementById("userInputText").placeholder = "Enter OTP...";
                                                    
                                              } 
       
//condition 2
 else if (response.data.status === "fail" && response.data.otpGenerated === "N" &&
  response.data.responseType === "otpExpired" ) {

    //console.log("expired OTP");
this.stopResendTimer();
  document.querySelectorAll('.resend-placeholder').forEach(el => {
    el.innerHTML = '';
  });
  const updatedMsg = response.data.error ;

  this.showAnimatedMessage(`⚠️ ${updatedMsg}`, 'color: red; font-weight: 600;');

                                 
           this.lastMessage = " ";
          document.getElementById("userInputText").placeholder = " Type EXIT";
  

  }


        //condition 3
        
     else if (response.data.status === "fail" && response.data.otpGenerated === "N" ) 
     {
 

      if (response.data.otpValidated==="N"){  
        //console.log("SM CnoI");      //wrong consumer
            
            const updatedMsg = response.data.error ;
              this.showAnimatedMessage(`⚠️ ${updatedMsg}`, 'color: red; font-weight: 600;');
                                  
  
           this.lastMessage = "Enter consumer number";
          document.getElementById("userInputText").placeholder = "Enter valid consumer number...";
  
} 

else if (response.data.otpValidated==="Y" &&  response.data.responseType === "otpInvalid") {

  //console.log("SM otpI")
 this.stopResendTimer();
 document.querySelectorAll('.resend-placeholder').forEach(el => {
    el.innerHTML = '';
  });

const updatedMsg = `${response.data.error} <br><span class="resend-placeholder"></span>`;
  this.showAnimatedMessage(`⚠️ ${updatedMsg}`, 'color: red; font-weight: 600;');

  this.lastMessage = "Re-enter OTP";

  setTimeout(() => {
    this.$nextTick(() => {
      this.showResendButtonTimer(); 
    });
  }, 1300); 
}
       }
       
       
       
      
      else if (response.data.status === "success") {
          if (response.data.otpValidated === "Y" && response.data.responseType === "menu") {
             //console.log("inside SM responseType === menu");
             //this.nextIsMenu = true; 
          this.stopResendTimer() ;
                                                    this.showBackToMenu = true;
                                                    const res = response.data.consDetails.split(",");
                                                    let msg = `
                                                        <div class="menu-animate"> <div style="text-align: left; font-size: 14px;">
                                                  <div style="display: flex; justify-content: space-between; flex-wrap: wrap; margin-bottom: 6px;">
                                                    <div style="flex: 1; min-width: 120px; margin-right: 10px; color: grey;">
                                                      Type: <span style="color: #E34A00; font-weight: 600;">${res[0]}</span>
                                                    </div>
                                                    <div style="flex: 1; min-width: 120px; color: grey;">
                                                      Load: <span style="color: #E34A00; font-weight: 600;">${res[1]} kw</span>
                                                    </div>
                                                  </div>

                                                  <div style="display: flex; justify-content: space-between; flex-wrap: wrap;">
                                                    <div style="flex: 1; min-width: 120px; margin-right: 10px; color: grey;">
                                                      Meter No: <span style="color: #E34A00; font-weight: 600;">${res[3]}</span>
                                                    </div>
                                                    <div style="flex: 1; min-width: 120px; color: grey;">
                                                      Status: <span style="color: #E34A00; font-weight: 600;">${res[2]}</span>
                                                    </div>
                                                  </div>
                                                <hr style="margin-top: 12px; margin-bottom: 12px;">
                                                      Hello,<span style="font-size: 14px; font-weight: bold;color: #E34A00">${this.ConsName}</span><br> Welcome to APDCL services! Please select from the options below:<br>
                                                    `;

                                          const buttons = response.data.msg.split(",");
                                        msg += `<div class="main-menu-grid">`;

buttons.forEach(btn => {
  msg += `
    <div class="main-menu-card"
         onclick='getResponse("${btn}")'>
      <div class="main-menu-text">${btn}</div>
    </div>
  `;
});

msg += `</div></div>`;


this.lastMessage = "";
this.stopAnimation();          
this.showBackToMenu = true;
this.removeOldMenu();
this.menu = {
  from: 'Apdcl',
  data: msg,
  time: dateTime,
  isMenuMsg: true
};

this.menuLevel = "MAIN";
this.currentCategory = "";

this.messages.push(this.menu);

document.getElementById("userInputText").placeholder = 'Type MENU or EXIT ';

this.$nextTick(() => {
  this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;
});

                                        } 

                                       
                                        
                                       else if (response.data.responseType === "menu") {
                                                  //this.showBackToMenu = true;
 //console.log("SM menu");                          // this.nextIsMenu = true; 
                                                  let msg = `
                                                    <div style="text-align: left; font-size: 14px;">
                                                      <div style="color: #E34A00; font-weight: 600; margin-bottom: 10px;">
                                                        ${response.data.msg}
                                                      </div>
                                                    </div>
                                                  `;

                                                  this.lastMessage = "";
                                                  this.fetchAnimation(msg);
                                                  this.menu = { from: 'Apdcl', data: msg };
                                                  document.getElementById("userInputText").placeholder = 'Type MENU or EXIT ';
}

                                        else if (response.data.responseType === "botResponse") {
                                               console.log("SM success botresponse");

                                                if (botMsg === "Update mobile number") {

      this.mobileTemp = "";
      this.lastMessage = "";

      this.stopResendTimer();

      document.getElementById("userInputText").placeholder =
          "Type MENU or EXIT";
  }
else if (botMsg === "Update email id") {

        this.emailTemp = "";
        this.lastMessage = "";

        document.getElementById("userInputText").placeholder =
            "Type MENU or EXIT";
    }
  
                                                    this.fetchAnimation(response.data.msg, () => {
                                                      this.stopAnimation();
                                                      
                                                     
                                                    this.messages.push({
                                                        from: 'Apdcl',
                                                        data: `<span style='color:#E34A00;font-size:1rem'>${response.data.msg}</span>`,
                                                      
                                                        time: dateTime
                                                      });
                                                    });
                                                  }

                                                   
                                                }

                                                else if (response.data.status === "fail" && response.data.responseType === "botResponse")  this.fetchAnimation(response.data.msg, () => {

                                                  //console.log("SM fail botresponse");
                                                      this.stopAnimation();
                                                      
                                                     
                                                    this.messages.push({
                                                        from: 'Apdcl',
                                                        data: `<span style='color: #E34A00;font-size:1rem'>${response.data.msg}</span>`,
                                                      
                                                        time: dateTime
                                                      });
                                                    });

                                                this.$nextTick(() => {
                                                  this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;
                                                });
                                              })
                                              .catch((error) => {
                                                this.stopAnimation();
                                                console.error(error);
                                                const errMsg = error  || "Something went wrong. Please try again.";
                                                this.showAnimatedMessage(`⚠️ ${errMsg}`, 'color: red; font-size: 1rem;');
                                              });
                                          });

                                          this.currentMessage = '';
                                          this.$nextTick(() => {
                                            this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;
                                          });
                                        },



getResponse(message){   
  //console.log("getResponse() called");

 // console.log("Menu clicked:", message);  
 //console.log("Menu clicked:", message,"menuLevel:",this.menuLevel,"nextIsMenu:",this.nextIsMenu); 

  var otpReq ="";
  var otpValidate="";
  var otp= "";
  this.currentMessage = message;

  var d = new Date();
  var dateTime = d.toString().split("GMT")[0];

  
  if (this.menuLevel === "MAIN") {
    this.nextIsMenu = true;      // MAIN → SUB (send isMenu=Y)
  } else {
    this.nextIsMenu = false;     // SUB → SUB-SUB (send isMenu="")
  }

  

  

  /* ---------- Service Calculator ---------- */
  if (message === "New Connection Estimate Calculation") {

    this.Category = "";
    this.Load = "";
    this.Owner = "";
    this.catCode = "";

    const errBox = document.getElementById("estError");
    if (errBox) errBox.innerText = "";

    this.$nextTick(() => {
      const cat = document.getElementById("selectCategory");
      const load = document.getElementById("load");
      const owner = document.getElementById("landOwner");
      const loadRange = document.getElementById("loadRange");

      if (cat) cat.value = "0";
      if (load) load.value = "";
      if (owner) owner.value = "0";
      if (loadRange) loadRange.innerHTML = "";
    });

    this.lastMessage = "SERVICE_CALCULATOR";
    this.showServiceCalculatorMenu();
    this.currentMessage = "";
    return;
  }

  const isInputPrompt = ["Update mobile number", "Update email id", "Check application status"];
  if (!isInputPrompt.includes(message)) {
    this.lastMessage = '';  
  }

  this.messages.push({
    from: 'user',
    data: message,
    time: dateTime
  });

  /* ---------- Input based flows ---------- */
  if(message === "Update mobile number") {
    this.lastMessage = message;
    this.showAnimatedMessage("Please Enter your mobile number", "color:#000;");
    this.currentMessage='';
    return;
  }
  else if(message === "Update email id") {
    this.lastMessage = message;
    this.showAnimatedMessage("Please Enter your email id", "color:#000;");
    this.currentMessage='';
    return;
  }
  else if(message === "Check application status") {
    this.lastMessage = message;
    this.showAnimatedMessage("Please Enter your application number", "color:#000;");
    this.currentMessage='';
    return;
  }
  else if(message === "Register complain") {
    this.currentMessage='';
    window.open('https://www.bijuleebandhu.com/', '_blank');
    this.$nextTick(() => { this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight; });
    document.getElementById("userInputText").placeholder = 'Type "MENU" or "EXIT"';
    return;
  }

  /* ---------- API PAYLOAD ---------- */
  let dataTosend = JSON.stringify({
    consNo: consNo,
    otpReq: otpReq,
    otpValidate: otpValidate,
    otp: otp,
    isMenu: this.nextIsMenu ? "Y" : "",
    mobNo:"",
    email:"",
    applNo:"",
    cat:"",
    load:"",
    botMsg: message
  });

 // console.log("DataToSend in getResponse:", dataTosend);

  let config = {
    method: 'post',
    url: 'https://uat.apdclrms.com/bot/bs/getBotResponse',
    headers: { 
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json'
    },
    data: dataTosend
  };

  /* ---------- Fetch animation ---------- */
  if(message.search(/bill/i)>=0) this.fetchAnimation(this.fetchMsg.bill);
  else if(message.search(/payment/i)>=0) this.fetchAnimation(this.fetchMsg.payment);
  else if(message.search(/prepaid balance/i)>=0) this.fetchAnimation(this.fetchMsg.balance);
  else if(message.search(/recharge/i)>=0) this.fetchAnimation(this.fetchMsg.recharge);
  else if(message.search(/statement/i)>=0) this.fetchAnimation(this.fetchMsg.statement);
  else if(message.search(/consumption/i)>=0 && message.search(/history/i)>=0)
    this.fetchAnimation(this.fetchMsg.consumptionHistory);
  else if(message.search(/balance history/i)>=0)
    this.fetchAnimation(this.fetchMsg.balanceHistory);
  else
    this.fetchAnimation(this.fetchMsg.defaultMsg);

  var parent = this;

  setTimeout(function() {

    axios.request(config)
    .then((response) => {

      d = new Date();
      dateTime = d.toString().split("GMT")[0];

      /* ---------- MENU RESPONSE ---------- */
      if (response.data.status === "success" && response.data.responseType === "menu") {

        const items = response.data.msg.split(",").map(i => i.trim());

        // MAIN → SUB state update
        if (parent.menuLevel === "MAIN") {
          parent.menuLevel = "SUB";
          parent.currentCategory = message;
        }

        
let msg = `
  <div class="menu-animate">
    <!--breadcrumb -->
    <div style="display:flex;align-items:center;gap:6px;font-size:12px;color:#777;margin-bottom:8px;">
      <span style="cursor:pointer;color:#004aad;font-weight:600;"
            onclick="window.backToMenu()">☰</span>
      <span>›</span>
      <span style="color:#333;font-weight:600;">
        ${parent.currentCategory}
      </span>
    </div>

    <div class="main-menu-grid">
`;



        items.forEach(btn => {
          msg += `
            <div class="main-menu-card"
                 onclick='getResponse("${btn}")'>
              <div class="main-menu-text">${btn}</div>
            </div>
          `;
        });

       /* msg += `
          </div>
          <div style="text-align:right;margin-top:10px;">
           /* <button class="btn back-menu-btn"
              onclick="window.backToMenu()">
              ⬅ Back
            </button>
          </div>
        `;*/

       parent.removeOldMenu();   // remove MAIN menu
parent.messages.push({
  from: 'Apdcl',
  data: msg,
  time: dateTime,
  isMenuMsg: true
});


        parent.showBackToMenu = true;
      }

      /* ---------- BOT RESPONSE ---------- */
      else if(response.data.status === "success" && response.data.responseType === "botResponse") {
        console.log("Entered here bot response");

        
        parent.messages.push({
          from: 'Apdcl',
          data: `<span style='color:#E34A00;font-size:1rem'>${response.data.msg}</span>`,
          time: dateTime
        });
      }
else if(response.data.status=="success" && response.data.responseType=="link" )
  {
    var msg=" <a target='_blank' href='"+response.data.msg+"' style=' color: #E34A00 !important;font-weight:500 !important;'><img src='https://www.apdcl.org/website/assets/pdf-icon-3.png' height='30px' width='30px' />Click here to "+message+"</a>";
      parent.messages.push({
        from: 'Apdcl',
        data: msg, 
        time:dateTime
      });
  }

 else if (response.data.status == "success" && response.data.responseType == "tips") {

  //console.log("GR tips");
  //console.log("currenttipindex",parent.currentTipIndex);
  const tips = response.data.msg.split(',').map(t => t.trim()).filter(t => t);

  parent.stopAutoSlide();

  parent.allTips = tips;
parent.carouselItems = tips;    
parent.carouselType = "tips";   
parent.currentCarouselIndex = 0; 
//remove old id
  parent.messages = parent.messages.filter(m => !(m.data && m.data.includes('id="tip-carousel"')))

  const tipHTML = `<div id="tip-carousel"></div>`;
  parent.messages.push({
    from: 'Apdcl',
    data: tipHTML,
    time: dateTime
  });

 parent.$nextTick(() => {
   
    parent.showTip(0); // always start at index 0
    parent.startAutoSlide();
  });
}

else if (response.data.status == "success" && response.data.responseType == "docs") {

  const docs = response.data.msg.split(',').map(t => t.trim()).filter(t => t);

  parent.stopAutoSlide();

  parent.allDocs = docs;
  parent.carouselItems = docs;
  parent.carouselType = "docs";
  parent.currentCarouselIndex = 0;

  parent.messages = parent.messages.filter(m => !(m.data && m.data.includes('id="nscdocs-carousel"')))

  const html = `<div id="nscdocs-carousel"></div>`;

  parent.messages.push({
    from: 'Apdcl',
    data: html,
    time: dateTime
  });

  parent.$nextTick(() => {
    parent.showDoc(0);
    parent.startAutoSlide();
  });
}


  else if(response.data.status=="success" && response.data.responseType=="graph" )
  {
  //console.log("this-currentMessage::::"+message);
    var data = response.data.msg;
    var label ="";
          var msg='<div id="GraphContainer'+i+'"><canvas id="consumptionChart'+i+'" height="250"></canvas></div>';
         
          parent.messages.push({
              from: 'Apdcl',
              data: msg, 
              time:dateTime,
              isGraph:true
            });
          if(message=="Consumption history")
            {
              label="Consumption(in KW)";
            }
            if(message=="Balance history")
            {
              label="Balance History";
            }
          setTimeout(function() {displayGraph(data,label)}, 10);
  }
   else if (response.data.status === "fail" && response.data.responseType === "botResponse") {

      //console.log("GR Fail botresponse");
      parent.showAnimatedMessage(response.data.msg, "color: #E34A00; font-size: 1rem;");
}
                                                  
                                                  
  else if(response.data.status=="fail" && response.data.otpGenerated=="N" )

  {

     // console.log("GR fail otpg N");

 parent.showAnimatedMessage(response.data.error, "color: #E34A00; font-size: 1rem;");
}
   else if (response.data.status === "fail" && response.data.responseType === "menu") {
   //// console.log("GR fail menu");
  parent.showAnimatedMessage(`⚠️ ${response.data.msg}`, 'color: #E34A00; font-size: 1rem;');
  parent.lastMessage = "Enter consumer number";
  //document.getElementById("userInputText").placeholder = "Enter consumer number...";
}
      /* ---------- FAIL ---------- */
      else if(response.data.status === "fail") {
        const errMsg = response.data.msg || response.data.error || "Something went wrong.";
        parent.showAnimatedMessage(`⚠️ ${errMsg}`, 'color:red;');
      }


      parent.$nextTick(() => {
        parent.$refs.chatbox.scrollTop = parent.$refs.chatbox.scrollHeight;
      });

    })
    .catch((error) => {
      console.error(error);
      parent.showAnimatedMessage("⚠️ Something went wrong.", 'color:red;');
    });

  }, 2000);

  this.currentMessage='';
},


  


  displayGraph(data,lb)
  {
    var chartData = [];
    var chartLabel = [];
    
    var bgColor = ['#ffab91','#ff8a65','#ff7043','#ff5722','#e64a19','#d84315','#d84315'];
    if(lb=="Balance")
    {
      bgColor = ['#a5d6a7','#81c784','#66bb6a','#4caf50','#43a047','#388e3c','#2e7d32'];
    }
      // var canvas = document.createElement("canvas");
    // canvas.id = "consumptionChart";
    // document.getElementById("GraphContainer").appendChild(canvas);

    var res = data.split(','); 
    res.forEach(element => {
      //console.log(element);
      var el = element.split(':');
     // console.log("Date"+el[0]);
      
      chartData.push(parseFloat(el[1]));
      chartLabel.push(el[0]);
    })
   // console.log("chartData:"+chartData);
    //console.log("chartLabel:"+chartLabel);
   
    var ctx = document.getElementById('consumptionChart'+i);
    i++;
    //console.log("i = "+i);
    var myChart = new Chart(ctx, {
      type: 'bar',
      data: {
      labels: chartLabel,
      datasets: [
        {
            label : lb,
            fill: true,
            backgroundColor: bgColor,
            data: chartData
        }
    ]
  } ,

  options: {
       responsive: true,
       lineTension: 1,
       scales: {
         yAxes: [{
           ticks: {
             beginAtZero: true,
             padding: 25,
           }
         }]
       }
     }
   });
     
 
}
  
},
mounted() {

  axios.post('https://www.apdclrms.com/cbs/RestAPI/crm/getAllCategoryList')
    .then((response) => {
      this.categoryList = response.data;  
      //console.log(this.categoryList);
    });


   window.__vue__ = this
  // Automatically open chatbot when loaded in iframe
  if (window.self !== window.top) {
    const chatIcon = document.getElementById("chatIcon");
    if (chatIcon) {
      chatIcon.click();
    }
  }
  
},
  created(){ 
    window.getResponse=this.getResponse;
    window.backToMenu=this.backToMenu;
    window.displayGraph= this.displayGraph;
  },
  
  
};
</script>

<style scoped>
/* @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500&display=swap'); */
/*  first bot img */

#chatIcon {
  height: 60px;
  width: 60px;
  position: fixed; 
  bottom: 130px;
  right: 24px;
  cursor: pointer;
 /* border-radius: 50%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);*/
  z-index: 9999;
  background: transparent;
  object-fit: fill;
}

/*  text above bot */
#chat-text {
  position: fixed;
  bottom: 190px; 
  right: 24px;
  z-index: 9999;
  cursor: pointer;
}

.chatbot-float-text {
  display: inline-block;
  padding: 10px 16px;
  font-size: 0.85rem;
  font-weight: bold;
  color: #ffffff;
  background: #004aad;
  border-radius: 20px 20px 20px 20px; 
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  text-align: center;
  pointer-events: none;
  transition: opacity 0.3s ease;
  animation: bounce 1.5s ease infinite;
  max-width: 160px;
  line-height: 1.3;
}

/*  text animation */
@keyframes bounce {
  0% {
    transform: translateY(0); /* Start at the original position */
  }
  25% {
    transform: translateY(-10px); /* Move up */
  }
  50% {
    transform: translateY(0); /* Return to the original position */
  }
  75% {
    transform: translateY(-5px); /* Move up slightly */
  }
  100% {
    transform: translateY(0); /* End at the original position */
  }
}
/*     chat box */

.chatbox-container {
  position: fixed;
  
  width:100%;
  max-width:400px;
  max-height: 90vh;
 bottom: 0;
  right: 0;
  left: auto;
  z-index: 1000;
  flex-direction: column;
  align-items: flex-end;
 
}

.chatbox-container {
  pointer-events: auto;
}

.chatbox-container:not(.chatbox-open) {
  pointer-events: none; /*  make links below clickable only when minimized */
}
.chatbox-container.chatbox-open {
  pointer-events: auto;
}
#chatIcon, 
#chat-text {
  pointer-events: auto; /* make links below clickable */
}


#chatbotContainer {
  max-height: 0;
  max-width: 0;
  overflow: hidden;
  transition: all 0.6s ease-in-out;
  opacity: 0;
  transform: scale(0.9);
}

#chatbotContainer.chatbox-open {
  max-height: 100%;
  max-width: 100%;
  opacity: 1;
  transform: scale(1);
}

/*.chat-bar-collapsible {
    position: fixed;
    bottom: 0;
    right: 0;
    
}*/

/*  header portion that contains the drop down*/

#chat-button {
  display: flex;
  align-items: center;
  background: #004aad;
  border: none;
  border-radius: 12px 12px 0 0;
  padding: 8px 14px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  gap: 10px;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}

.collapsible {
    background-color: rgb(82, 151, 255);
    color: white;
    cursor: pointer;
    padding: 15px;
    width: 400px;
    max-width: 100%;

    text-align: left;
    outline: none;
    font-size: 18px;
    border-radius: 10px 10px 0px 0px;
    /* border: 3px solid white; */
    border-bottom: none;
}

.chat-toggle-hamburger {
  display: flex;
  align-items: flex-start;
  background: linear-gradient(to right, #007bff, #0056b3);
  color: white;
  border: none;
  padding: 10px 15px;
  width: 80%;
  gap: 8px;
 
}

.chat-text-group {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.chatboxtop-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
}

/*  image on the header*/

.apdclbot-img {
  width: 60px;
  height: 60px;
  
  /*box-shadow: 0 2px 8px rgba(255, 255, 255, 0.687);
  object-fit: cover;
  
  border-radius: 50%;*/
  background: transparent !important;;
  margin: 0; /* remove spacing */
  
}

/* BIJULEESEWA!*/


.bot-title-group {
  display: flex;
  align-items: center;
  gap: 8px; /* Reduce or set to 0 if needed */
}

/*.apdclbot-img {
  width: 55px;
  height: 55px;
  border-radius: 50%;
  object-fit: cover;
  margin: 0; }/* remove spacing */


.bot-title-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #fff;
  font-family: 'Roboto', sans-serif;
  margin-left: 0; /* remove unwanted margin */
}

.bot-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 1;
  text-transform: capitalize;
  letter-spacing: 0.5px;
}

.chat-subtitle {
  font-size: 0.75rem;
  color: #cfdfff;
  margin-top: 0px;
  font-weight: 400;
  letter-spacing: 0.2px;
}

/* hamburger */
.hamburger-dropdown {
  padding: 0;
  background: transparent;
  border: none;
}

.hamburger-icon {
  cursor: pointer;
  color: white;
}

/* force style only this dropdown */
.chat-dd-menu {
  min-width: 100px;
  padding: 4px 0;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  box-shadow: 0 4px 10px rgba(0,0,0,0.12);
  
}


.chat-dd-menu .dd-text {
  font-family: "Segoe UI", system-ui, Arial, sans-serif;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.2px;
  color: #333;
}


.chat-dd-menu .dropdown-item:hover .dd-text {
  color: #004aad;
}


.chat-dd-menu .dd-icon {
  font-size: 1rem;
  color: #004aad;
}

.chat-dd-menu .dd-icon.danger {
  color: #dc3545;
}
.chat-dd-menu .dropdown-divider {
  margin: 4px 0;
  border-top: 1px solid #eee;
}


/*  message display area*/
  .container {
  padding-left: 0;
  padding-right: 0;
  width: 100%;
  max-width:450px;
  min-height: 400px;
  /*max-height: calc(100% - 60px); */
  max-height:70vh;
  height: 70vh; 
  
  overflow-y: auto;
  background-color: white;
  
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: 'Roboto', sans-serif;
  /*-webkit-transition:height 0.8s;
  transition: transform 2s ease-in-out;*/
  transition: max-height 0.4s ease-in-out, opacity 0.3s ease;
}
.container.is-open {
  max-height: 500px;
  opacity: 1;
}

/* message/chat box bubble */
.input-error {
  border: 2px solid #ff4d4d !important;
  background: #ffecec;
  animation: shakeInput 0.25s ease;
}

@keyframes shakeInput {
  0% { transform: translateX(0); }
  25% { transform: translateX(-4px); }
  50% { transform: translateX(4px); }
  75% { transform: translateX(-4px); }
  100% { transform: translateX(0); }
}


.messageBox {
  /*max-height:100%;*/
  overflow-y: auto;
  padding: 0 16px;
  border-top: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
  flex-grow: 1;
  background-color: #7cc9ef42;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  scroll-behavior: smooth;
}

.messageFromUser{
    display: flex;
    float:right;
    flex-direction: column; 
  align-items: flex-start;
  margin-bottom: 12px;
  position: relative;
}
.messageFromApdcl {
  display: flex;
  flex-direction: column; 
  align-items: flex-start;
  margin-bottom: 12px;
  position: relative;
  float:left;
  font-style: italic;
}


.userAvatar b-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #d3e3fd;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  color: #1877F2;
  margin-right: 6px;
}

.apdclAvatar img {
  background-color: transparent;
  color: #222;
  /*box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
  border-radius: 50%; */
  width: 40px;
  height: 40px;
  
  display: flex;
  align-items: center;
  justify-content: center;
  
  
  margin-bottom: 4px;
  
}

.userMessageWrapper,
.ApdclMessageWrapper {
  display: flex;
  flex-direction: column;
}

.userMessageWrapper {
  align-self: flex-end;
}

.ApdclMessageWrapper {
  align-self: flex-start;
}

.userMessageContent{
    
  max-width: 100%;
  padding: 8px 12px;
  border-radius: 18px;
  margin-bottom: 2px;
  font-size: 14px;
  line-height: 1.4;
  text-align:right;
  background-color: #1877F2;
  color: white;
  border-top-right-radius: 0;
}
.ApdclMessageContent {
  max-width: 100%;
  padding: 8px 12px;
  border-radius: 18px;
  margin-bottom: 2px;
  font-size: 14px;
  line-height: 1.4;
  text-align:left;
  background-color: #ffffff;
  color: #222;
  border-top-left-radius: 0;
  box-shadow: grey 1px 1px 5px 0px;
}

/*  Typing DOTS */

/*.typingIndicatorWrapper {
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
}*/


/*  Time  eg Sat May 03 2025 20:44:53*/ 
.timeClass{
  font-size: 0.7rem;

  color:#939495;
  text-align: left;
  padding-left:10px;
}



/*  TYPING CAR        */

.typingIndicatorWrapper {
  position: relative;
  width: 100%;
  height: 40px;      
  overflow: hidden;  /*  add visible if it should be move inside the wrapper*/
  display: flex;
  align-items: center;
  background: transparent; /* no background */
  pointer-events: none;    /* car won’t block clicks */
}

/* car loader */

/* Wrapper for typing indicator */
.typingIndicatorWrapper {
  position: relative;
  width: 100%;
  height: 40px;
  overflow: hidden;          
  display: flex;
  align-items: center;
  background: transparent;
  pointer-events: none;
}

/* =====================
   CAR CONTAINER
   ===================== */
.car-loader {
  position: absolute;
  left: -130px;              /* start outside bubble */
  height: 40px;
  animation: drive-car 5s linear infinite; /* 🔧 speed control */
  will-change: transform;
}

/* =====================
   CAR BODY
   ===================== */
.car__body {
  stroke: #1877F2;                 /* APDCL blue */
  stroke-width: 3;
  fill: rgba(224, 97, 5, 0.18);     /* soft orange fill */
  animation: body-bounce 1.4s ease-in-out infinite;
}

/* =====================
   WHEELS
   ===================== */
.car__wheel--left,
.car__wheel--right {
  fill: #ffffff;
  stroke: #df5d00;
  transform-origin: center;
  transform-box: fill-box;
  animation: wheel-spin 1.2s linear infinite;
}

/* =====================
   SPEED LINES
   ===================== */
.car__line {
  stroke: #df5d00;
  stroke-dasharray: 22;
  animation: speed-lines 1s linear infinite;
}

.car__line--top {
  animation-delay: 0s;
}

.car__line--middle {
  animation-delay: 0.15s;
}

.car__line--bottom {
  animation-delay: 0.3s;
}

/* =====================
   ANIMATIONS
   ===================== */

/* LEFT → RIGHT movement */
@keyframes drive-car {
  0% {
    transform: translateX(0);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  100% {
    transform: translateX(420px); /* adjust if needed */
    opacity: 0;
  }
}

/* Wheel rotation */
@keyframes wheel-spin {
  100% {
    transform: rotate(360deg);
  }
}

/* Subtle body bounce */
@keyframes body-bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(2px);
  }
}

/* Speed line motion */
@keyframes speed-lines {
  from {
    stroke-dashoffset: 22;
  }
  to {
    stroke-dashoffset: -22;
  }
}



/* Car emoji  */
/*.car-emoji {
  position: absolute;
  left: -40px;          /* start offscreen  hidden before it enters view 
  font-size: 2rem;    /* adjust size 
  transform: scaleX(-1); 
  animation: drive 5s linear infinite ; /* if slow then increase 5s to 8s 
}
/* Move car from left to right 
@keyframes drive {
  0% { left: -60px; }
  100% { left: 100%; }
}

/* === shadow below car === 
.typingIndicatorWrapper::after {
  content: "";
  position: absolute;
  bottom: 5px;
  left: 0;
  width: 100%;
  height: 5px;
  background: radial-gradient(ellipse at center, rgba(0,0,0,0.25), transparent);
  filter: blur(3px);
 
}*/

.close-chatbot {
  position: absolute;
  top: 5px;
  right: 5px;
  background: #fff;
  border: none;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  font-size: 1.2rem;
  line-height: 1;
  cursor: pointer;
  box-shadow: 0 0 6px rgba(0,0,0,0.2);
}

/*  input area , placeholder etc */


.inputContainer {
  display: flex;
  align-items: center;
  padding: 8px;
  background-color: #004aad;
}

.messageInput {
  flex-grow: 1;
  border: none;
  outline: none;
  padding: 12px;
  font-size: 16px;
  background-color: white;
  border-radius: 24px;
  margin-right: 8px;
}

.askButton {
  background-color: #1877F2;
  color: white;
  font-size: 16px;
  padding: 8px 16px;
  border: none;
  outline: none;
  cursor: pointer;
  border-radius: 24px;
  transition: background-color 0.3s ease-in-out;
}

.askButton:hover {
  background-color: #9ecde2;
  color:#171616;
}

#userInputText {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
#userInputText::placeholder {
    font-size: 14px; 
    font-weight: bold;
    color: #575555;
    text-overflow: ellipsis; 
    word-wrap: break-word;
    white-space: pre-wrap;
}
.userMessageTimestamp,
.ApdclMessageTimestamp {
  font-size: 10px;
  color: #999;
  margin-top: 2px;
}

.userMessageTimestamp {
  align-self: flex-end;
}

.ApdclMessageTimestamp {
  align-self: flex-start;
}

/*Back to Menu button */
.back-menu-btn {
  border: none;
  border-radius: 25px;
  padding: 6px 10px;
  background-color: #fff;
  color: #355fdc;
  font-size: 16px;
  font-weight: 500;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.3s ease;
  position: relative;
}

.back-menu-btn:hover,
.back-menu-btn:focus {
  background-color: #144fc4;
  color: #fff;
}

.btn-label {
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.2s ease, visibility 0.2s ease;
      white-space: nowrap;
}

.back-menu-btn:hover .btn-label,
.back-menu-btn:focus .btn-label {
  opacity: 1;
      visibility: visible;
}


html {
  font-size: 16px;
}



  /* RESPONSIVE DESIGN */
  @media (min-width: 768px) and (max-width: 1366px) { 
    /*Tablet to Small Laptop (min-width: 768px and max-width: 1366px) */
  .chatbox-container {
    width: 500px;
  }

  .collapsible {
    width: 500px;
    font-size: 18px;
  }

  .container {
    max-height: 75vh;
  }
}
@media (min-width: 481px) and (max-width: 1024px) {
  
  /*  Medium to Small Tablets (min-width: 481px and max-width: 1024px)*/
  #chat-button {
    width: 100%;
    max-width: 500px;
  }

  .chatboxtop-row {
    flex-wrap: nowrap;
    align-items: center;
  }

  .chatbox-container {
    max-width: 100% !important;
    
    right: 0;
    left: auto;
    padding: 0 16px;
    align-items: center;
    justify-content: flex-end;
    bottom: 0;
  }

  .collapsible {
    width: 100%;
    font-size: 16px;
    max-height: 70vh;
  }

  .messageBox {
    padding: 12px;
  }

  .messageInput, .askButton {
    font-size: 14px;
    padding: 10px;
  }
}

  

  @media (max-width: 480px) {

   /*  Mobile (max-width: 480px) */

    #chat-button {
    max-width: 100%;
    padding: 8px 10px;
  }

  .apdclbot-img {
    width: 45px;
    height: 45px;
  }
    .chatbox-container {
    max-width: 100% !important;
    right: 0;
    left: auto;
    padding: 0 8px;
  }

  .container {
    width: 100%;
    border-radius: 0;
  }

  .collapsible {
    width: 100%;
  }

  .messageFromUser,
  .messageFromApdcl {
    display: flex;
  }

  .messageInput, .askButton {
    font-size: 12px;
    padding: 8px;
  }

    html {
    font-size: 15px;
  }
  }















</style>
<style>



  
/* ===== MAIN MENU (LEVEL 0) ===== */

.main-menu-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  margin-top: 10px;
}

.main-menu-card {
  background: #ffffff;
  border: 1px solid #17a2b8;
  border-radius: 14px;
  padding: 14px 10px;
  text-align: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.25s ease;
}

.main-menu-card:hover {
  background: #004aad;
  color: #ffffff;
  transform: translateY(-2px);
}

.main-menu-text {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
}

/* Smooth menu replacement */
.menu-animate {
  animation: menuFadeSlide 0.18s ease-out;
}

@keyframes menuFadeSlide {
  from {
    opacity: 0;
    transform: translateX(10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

</style>
